export const feedbackQuestion = (state = {isAnswer:false, data:[]},  action) => {
    switch (action.type) {
        case 'SET_FEEDBACK_QUE':
            const newState = {isAnswer:action.isAnswer, data:action.data}
            return newState;
        default:
            return state;
    }
}

export const feedbackSummery = (state = [],  action) => {
    switch (action.type) {
        case 'SET_FEEDBACK_SUMMERY':
            return action.data;
        default:
            return state;
    }
}